import React from 'react';
import './Buy.css';

export const Buy: React.FC<{}> = () => {
  return <p className="buy">Nothing here</p>;
};
